<template>
  <loading-state
    v-if="!method"
    :loading="true"
  />
  <v-layout
    v-else
    row
    wrap
    color="transparent"
  >
    <v-flex
      v-if="method"
      xs12
      ma-3
    >
      <translations-tabs
        class="pb-4"
      >
        <template #default="{language}">
          <translatable
            :language="language"
            v-model="method"
            field-name="name"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('name')"
                :label="$t('Name')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
          <translatable
            :language="language"
            v-model="method"
            field-name="description"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('description')"
                :label="$t('Description')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
        </template>
      </translations-tabs>
      <v-text-field
        v-model="method.merchantId"
        :error-messages="method.displayErrors('merchantId')"
        :label="$t('Merchant ID')"
        outline
      />
      <v-text-field
        v-model="method.username"
        :error-messages="method.displayErrors('username')"
        :label="$t('Username')"
        outline
      />
      <v-text-field
        v-model="method.password"
        :error-messages="method.displayErrors('password')"
        :label="$t('Password')"
        type="password"
        outline
      />
      <v-switch
        v-model="method.integrationTesting"
        :label="$t('Integration Testing')"
        outline
      />
      <v-text-field
        v-model.number="method.order"
        :error-messages="method.displayErrors('order')"
        :label="$t('Order')"
        type="number"
        outline
      />
      <application-select v-model="method.application"/>
      <image-upload v-model="method.image"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import LoadingState from '@/components/LoadingState'
import ImageUpload from '@/components/ImageUpload'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'

export default {
  name: 'PaymentConverge',
  components: { Translatable, TranslationsTabs, ImageUpload, LoadingState, ApplicationSelect },
  props: {
    method: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      schema: {
        'code': '',
        'name': '',
        'enabled': true,
        'application': null,
        'description': '',
        'image': '',
        'order': '',
        'testMode': false,
        'merchantId': '',
        'username': '',
        'password': '',
        'integrationTesting': false
      },
      sensitiveErrorFields: {
        username: 'username',
        password: 'password'
      }
    }
  },

  created () {
    this.$emit('setPaymentData', {
      schema: this.schema,
      sensitiveErrorFields: this.sensitiveErrorFields
    })
  }
}
</script>
